import PAGE_TYPES from 'tradera-constants/page-types';

/**
 * Takes current filter and a new tag, removes or adds the tag depending on if it already exists
 * @param {string[]} currentTagFilter
 * @param {string} tag
 * @returns {string[]}
 */
const addOrRemoveTagFilter = (currentTagFilter, tag) => {
    return currentTagFilter.includes(tag)
        ? currentTagFilter.filter(b => {
              return b !== tag;
          })
        : [...currentTagFilter, tag];
};

/**
 * Converts array to ; separated string, returns undefined if empty
 * @param {string[]} tags
 * @returns {string}
 */
const createTagFilterString = tags =>
    tags !== undefined && tags.length > 0 ? tags.join(';') : undefined;

/**
 * take an object or a string, a filter and a value and returns object with filter set to ;-separated string of values. returns undefined if empty
 * @param {object} attributeFilters
 * @param {string} filter
 * @param {string[]} values
 * @returns {string}
 */
const createAttributeFilter = (attributeFilters, filter, values) => {
    const activeAttributeFilter = attributeFilters.find(
        attribute => attribute.parameter === filter
    );

    let activeFilterTags = [];
    if (Array.isArray(values)) {
        activeFilterTags = values;
    } else {
        activeFilterTags = addOrRemoveTagFilter(
            activeAttributeFilter.selectedValues,
            values
        );
    }

    const activeFilterTagString = createTagFilterString(activeFilterTags);
    return { [filter]: activeFilterTagString };
};

/**
 * Takes the attributefilters, a filter and a tag in that filter and returns if the filter and tag does NOT exist in the attributefilters (true) or if it does exist (false)
 * @param {object} attributeFilters
 * @param {object} filter
 * @param {string} tag
 * @returns {boolean}
 */
const isTagNotInAttributeFilters = (attributeFilters, filter, tag) => {
    const isActiveAttributeFilter = attributeFilters.find(
        attribute => attribute.parameter === filter
    );
    return (
        isActiveAttributeFilter === undefined ||
        isTagNotInTagFilter(isActiveAttributeFilter.selectedValues, tag)
    );
};

/**
 * Takes a tag and a tagfilter and returns if the tag does NOT exists in the tagfilter (true) or if it does (false)
 * @param {string} tag
 * @param {string[]} tagFilter
 * @returns {boolean}
 */
const isTagNotInTagFilter = (tagFilter, tag) => {
    return (
        tagFilter === undefined || tag === undefined || !tagFilter.includes(tag)
    );
};

const resolveHeaderCategory = (
    activeCategory = {},
    categories = [],
    categoryId,
    categoryTree = {},
    introText,
    headerText,
    pageType
) => {
    if (pageType === PAGE_TYPES.CUSTOM_RESULT_PAGE) {
        return {};
    }
    const headerCategory = {
        categoryName:
            activeCategory.alternativeName ||
            activeCategory.name ||
            categoryTree.name,
        categoryId: activeCategory.id || categoryTree.id,
        introText,
        headerText,
        rootCategoryId: categoryTree ? categoryTree.id : 0
    };
    if (!headerCategory.categoryName && categoryId) {
        const category = categories.find(c => c.id === categoryId) || {};
        headerCategory.categoryName = category.name;
        headerCategory.categoryId = category.id;
    }
    return headerCategory;
};

export {
    createAttributeFilter,
    isTagNotInAttributeFilters,
    isTagNotInTagFilter,
    resolveHeaderCategory
};
